import { render } from "./TheSubscriptionsList.vue?vue&type=template&id=204c2db8"
import script from "./TheSubscriptionsList.vue?vue&type=script&lang=js"
export * from "./TheSubscriptionsList.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__